module.exports = __webpack_public_path__ + "static/media/select-teams-chain.7d4e7313.svg";